<script lang="ts" setup>
// Properties
const props = defineProps({
    type: {
        type: String,
        default: "button",
    },
    px: {
        type: String,
        default: "px-6",
    },
    py: {
        type: String,
        default: "py-1.5 md:py-2.5",
    },
});

// Data
</script>

<template>
    <NuxtLink
        v-if="type.toLowerCase() === 'link'"
        class="border-primary text-primary hover:border-abc-blue hover:text-abc-blue focus:bg-abc-blue active:border-primary-darker active:bg-primary-darker dark:ring-offset-abc-blue inline-block rounded-full border-2 bg-white text-center font-semibold no-underline! focus:border-white focus:text-white focus:ring-1 focus:ring-offset-1 active:text-white disabled:border-gray-300 disabled:text-gray-300"
        :class="px + ' ' + py"
    >
        <slot></slot>
    </NuxtLink>
    <button
        v-else
        :type="type"
        class="border-primary text-primary hover:border-abc-blue hover:text-abc-blue focus:bg-abc-blue active:border-primary-darker active:bg-primary-darker dark:ring-offset-abc-blue rounded-full border-2 bg-white text-center font-semibold focus:border-white focus:text-white focus:ring-1 focus:ring-offset-1 active:text-white disabled:border-gray-300 disabled:text-gray-300"
        :class="px + ' ' + py"
    >
        <slot></slot>
    </button>
</template>
